
<template>
    <div>
        <Modal
            :mask-closable="false"
            v-model="mergeSport.mergeModal"
            title="相似运动会列表"
            width="760"
            @on-cancel="disableds=false"
            :footerHide="true"
        >
             <Table :loading="loading"  stripe border :columns="mergeSport.mergeSportColumns" :data="mergeSportData" @on-selection-change="checkBoxs"></Table>
             <div class="mergeSubmit">
                <Button type="primary" size="large"   @click="mergeSubmit">合并运动会</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import {findByGameNameOrBeginTime,gameMerge} from '@/lib/api/index.js'

export default {
    props:['mergeSport'],
    data() {
        return {
          loading:true,
          multipleSelection:[],//选中的列表
          mergeSportData:[]
        }
    },
    methods: {
      mergeSubmit()
      {
        if(this.multipleSelection.length>1)
        {
            this.$Message.info("最多只能选择一个目标运动会");
        }else if(!this.multipleSelection.length)
        {
            this.$Message.info("最少要选择一个目标运动会");
        }else{
            this.$Modal.confirm({
                title: '你确认要合并运动会吗？',
                content:`<p>合并后的运动会名称：（&nbsp;${this.multipleSelection[0].gameNameCHN}&nbsp;）</p>`,
                onOk: () => {
                  

                  const obj = {
                      fromGameID:this.mergeSport.obj.gameID,
                      toGameID:this.multipleSelection[0].gameID
                  }

                  gameMerge(obj).then(res => {
                      if(res.data.code == 0){
                          this.$Message.info('合并成功');
                          this.$emit('upData');
                          this.mergeSport.mergeModal = false;
                      }else if(res.data.code == -2){
                          this.$Message.error("网络连接失败");
                      }else if(res.data.code==10)
                      {
                          this.$Message.info("登录token过期请重新登录");
                          this.$store.dispatch('loginOut');
                      }else{
                          this.$Message.error(res.data.msg);
                      }
                  },err =>{
                      this.$Message.error("网络连接失败");
                  });
                }
            });
        }
      },
      // 点击复选框回调
      checkBoxs(val){
          this.multipleSelection = val // 返回的是选中的列的数组集合
      },
    },
    mounted() {
        let beginTime = {
          beginTime: this.$PlugIn.formatDateTime(this.mergeSport.obj.beginTime)
        }
        findByGameNameOrBeginTime(beginTime).then(res => {
            this.loading = false;
            if(res.data.code == 0){
               this.mergeSportData = [];
               res.data.data.results.map((item)=>{
                   if(item.gameID!=this.mergeSport.obj.gameID)
                   {
                       this.mergeSportData.push(item);
                   }
               });
               
            }else if(res.data.code == -2){
                this.$Message.error("网络连接失败");
                this.disableds = false;
            }else if(res.data.code==10)
            {
                this.$Message.info("登录token过期请重新登录");
                this.$store.dispatch('loginOut');
            }else{
                this.$Message.error(res.data.msg);
                this.disableds = false;
            }
        },err =>{
            this.$Message.error("网络连接失败");
        });
    }
}
</script>
<style scoped>
  .mergeSubmit{text-align:center;padding-top:22px;}
</style>


// WEBPACK FOOTER //
// src/components/mergeModal.vue